module.exports = __webpack_public_path__ + "static/assets/ea2a238468543b0a5061314805bd8462.png";